<svelte:options tag={null} />

<script lang="ts">
  import "@everymatrix/em-accordion/dist/em-accordion";
  import { get_current_component } from "svelte/internal";
  import type { 
    OmPlayerLimits, 
    OmSportsLimits, 
    Sport 
  } from "../types/SportLimit.types";


  export let limits: OmPlayerLimits;
  export let sports;
  export let success:any;
  export let error:any;


  let sportLimit: OmSportsLimits = {
    liabilityBySportId: {},
    maxStakeBySportId: {},
    preLivePendingTimeBySportId: {},
    livePendingTimeBySportId: {}
  };

  let selectedSport: Sport;

  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleSave = (type) => {
    if(type === 'general') {
      // Liability
      (limits.liability === null || !limits.hasOwnProperty('liability')) ? 
        limits.liability = 100 : 
        limits.liability;
      // Max Stake
      (limits.maxStake === null || !limits.hasOwnProperty('maxStake')) ? 
        limits.maxStake = 100 : 
        limits.maxStake;
      // Live Pending Time 
      (limits.livePendingTime === null || !limits.hasOwnProperty('livePendingTime')) ? 
        limits.livePendingTime = 0 : 
        limits.livePendingTime;
      // Pre Live Pending Time
      (limits.preLivePendingTime === null || !limits.hasOwnProperty('preLivePendingTime')) ? 
        limits.preLivePendingTime = 0 : 
        limits.preLivePendingTime;

      // send custom Event
      dispatchWcEvent('change', { limits, type });
    }

    if (type === 'sports') {
      for(const [key, value] of Object.entries(sportLimit)) {
        if(!sportLimit[key].hasOwnProperty(selectedSport.id) || sportLimit[key][selectedSport.id] === null) {
          error = { 
            sportsLimit: "Invalid input, cannout have empty value" 
          };

          return;
        }
      }
      dispatchWcEvent('change', { limits: {"sportsLimits": sportLimit}, type });
    }
  };
</script>


<!-- General Limits -->
{#if limits}
<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      General Limits
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content general">
        <div class="form__content">
          <form 
            class="form"
            on:submit|preventDefault={() => handleSave('general')}
          >
            <!-- Liability Limit -->
            <label class="limit">
              <span class="limit__title">
                Liability Limit
              </span>
              <div class="limit__field">
                <input 
                  type="number"
                  min="0"
                  bind:value={limits.liability}
                  placeholder="100"
                >
                <span class="limit__symbol">&#37;</span>
              </div>
              <!-- Save Button -->
              <button  class="button" type="submit">
                Save
              </button>
            </label>
          </form>
          <!-- Max Stake Limit -->
          <form 
            class="form"
            on:submit|preventDefault={() => handleSave('general')}
          >
            <label class="limit">
              <span class="limit__title">
                Max Stake Limit
              </span>
              <div class="limit__field">
                <input 
                  type="number" 
                  min="0" 
                  bind:value={limits.maxStake}
                  placeholder="100"
                >
                <span class="limit__symbol">&#37;</span>
              </div>
              <!-- Save Button -->
              <button  class="button" type="submit">
                Save
              </button>
            </label>
          </form>

          <!-- Live Pending Limit -->
          <form 
            class="form"
            on:submit|preventDefault={() => handleSave('general')}
          >
            <label class="limit">
              <span class="limit__title">
                Live Pending Time
              </span>
              <div class="limit__field">
                <input 
                  type="number" 
                  min="0" 
                  bind:value={limits.livePendingTime}
                  placeholder="0"
                >
                <span class="limit__symbol">sec</span>
              </div>
              <!-- Save Button -->
              <button  class="button" type="submit">
                Save
              </button>
            </label>
          </form>
          <!-- Pending Time Limit -->
          <form 
            class="form"
            on:submit|preventDefault={() => handleSave('general')}
          >
            <label class="limit">
              <span class="limit__title">
                PreLive Pending Time
              </span>
              <div class="limit__field">
                <input 
                  type="number" 
                  min="0" 
                  bind:value={limits.preLivePendingTime}
                  placeholder="0"
                >
                <span class="limit__symbol">sec</span>
              </div>
              <!-- Save Button -->
              <button  class="button" type="submit">
                Save
              </button>
            </label>
          </form>
            <!-- Suspend Cashout -->
            <form 
              class="form"
              on:submit|preventDefault={() => handleSave('general')}
            >
              <label class="limit">
                <span class="limit__title">
                  Suspend Cashout
                </span>
                <div class="limit__field">
                  <select 
                    class="select"
                    bind:value={limits.suspendCashout}
                  >
                    <option value={null}>Unset</option>
                    <option value={true}>True</option>
                    <option value={false}>False</option>
                  </select>

                  <span class="limit__symbol"></span>
                </div>
                <!-- Save Button -->
                <button  class="button" type="submit">
                  Save
                </button>
              </label>
            </form>
        </div>
      
      {#if success === 'general'}
        <p class="success">Limit saved succesfully</p>
      {:else if error}
        <p class="error">Something went wrong</p>
      {/if}
    </div>
  </em-accordion>
</div>

<!-- Limit By Sport -->
<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      Sports Limits
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content">
      <form
        class="form"
        on:submit|preventDefault={() => handleSave('sports')}
      >
        <label class="limit">
          <span class="limit__title">
            Sport
          </span>
          <select 
            class="select" 
            bind:value={selectedSport}
          >
            {#each sports as sport}
              <option value={sport}>
                {sport.name}
              </option>
            {/each}
          </select>
        </label>

        {#if selectedSport}
          <label class="limit">
            <span class="limit__title">
              Liability Limit
            </span>
            <input 
              type="number" 
              min="0" 
              step="any"
              placeholder="100"
              bind:value={sportLimit.liabilityBySportId[selectedSport.id]} 
            >
            <span class="limit__symbol">&#37;</span>
          </label>

          <label class="limit">
            <span class="limit__title">
              Max Stake Limit
            </span>
            <input 
              type="number" 
              min="0" 
              step="any"
              placeholder="100"
              bind:value={sportLimit.maxStakeBySportId[selectedSport.id]}
            >
            <span class="limit__symbol">&#37;</span>
          </label>

          <label class="limit">
            <span class="limit__title">
              Live Pending Time
            </span>
            <input 
              type="number" 
              min="0"
              placeholder="0"
              bind:value={sportLimit.livePendingTimeBySportId[selectedSport.id]} 
            >
            <span class="limit__symbol">sec</span>
          </label>

          <label class="limit">
            <span class="limit__title">
              PreLive Pending Time
            </span>
            <input
              type="number" 
              min="0"
              placeholder="0"
              bind:value={sportLimit.preLivePendingTimeBySportId[selectedSport.id]}
            >
            <span class="limit__symbol">sec</span>
          </label>
        {/if}

        {#if success === 'sports'}
          <p class="success">Limit saved succesfully</p>
        {:else if error}
          <p class="error">Something went wrong</p>
        {/if}

        <!-- Save Button -->
        <button class="button" type="submit">
          Save
        </button>
      </form>
    </div>
  </em-accordion>
</div>
{:else}
  <p style="color: red; font-size: 14px;">
    Something is wrong, try again later
  </p>
{/if}


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }

  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .limit {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    cursor: pointer;

    &__title {
      width: 100%;
      margin-bottom: 20px;
      font-size: 12px;
      font-weight: bold;
    }

    &__field {
      display: flex;
      align-items: center;
      width: 100%;

      @media (min-width: 580px) {
        width: auto;
      }
    }

    &__symbol {
      font-weight: 400;
      font-size: 12px;
    }

    input {
      width: 100%;
      max-width: 250px;
      display: inline-flex;
      padding: 5px 10px;
      margin-right: 10px;
    }

    select {
      width: 100%;
      width: 205px;
      padding: 8px;
    }
  }

  .button {
    display: block;
    width: 150px;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }

  .general {

    .limit {
      flex-direction: column;
      align-items: flex-start;

      @media (min-width: 580px) {
        flex-direction: row;
        align-items: center;
      }
    }

    .limit__field input,
    .limit__field select {
      max-width: 100%;
      @media (min-width: 580px) {
        max-width: 250px;
      }
    }

    .limit__field select {
      width: 100%;
      @media (min-width: 580px) {
        width: 205px;
      }
    }

    .button {
      margin-left: 0;
      margin-top: 20px;
      align-self: center;
      @media (min-width: 580px) {
        margin-left: 10px;
        margin-top: 0;
      }
    }
  }

  .success,
  .error { margin: 10px 0; }

  .success { color: green; }
  .error { color: red; }
</style>
